/**
 * CONCEIVABLE — SUPPLEMENTS HOME
 * ---------------------------------------------------------------------------
 * Two small pieces of life on /pages/supplements:
 *   1. the ingredient marquee, filled from the real catalog rather than a
 *      hand-typed list that goes stale the moment a product changes
 *   2. the rotating first name in "a pack made just for ___"
 * Both are decorative. If the catalog fetch fails the page still reads fine.
 */
(function () {
  'use strict';

  var root = document.getElementById('cv-sh');
  if (!root) return;

  /* ------------------------------------------------------- ingredient marquee */

  var track = document.getElementById('cv-sh-track');
  var script = document.querySelector('script[data-catalog]');
  var url = script ? script.getAttribute('data-catalog') : null;

  // KK 2026-08-27: the catalog used to load only when the marquee existed, and
  // it is decorative. The pack panel needs it for the real pill photographs, so
  // it loads whenever we have a URL and the marquee is just one consumer.
  var CATALOG = {};
  if (url) {
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        products.forEach(function (p) {
          if (p && p.name) CATALOG[String(p.name).toLowerCase()] = p;
        });
        if (!track) return;
        var names = products.map(function (p) { return p.name; });
        if (!names.length) return;
        // Duplicated once so the -50% keyframe loops without a visible seam.
        // 2026-10-07: the second copy is aria-hidden and marked .cv-sh__dup so the
        // reduced-motion (static, wrapped) layout can hide it; only the moving
        // marquee needs it.
        var clean = function (n) { return String(n).replace(/[&<>]/g, ''); };
        var html = names.map(function (n) { return '<span>' + clean(n) + '</span>'; }).join('')
          + names.map(function (n) { return '<span class="cv-sh__dup" aria-hidden="true">' + clean(n) + '</span>'; }).join('');
        track.innerHTML = html;
      })
      .catch(function () { /* decorative, leave it empty */ });
  }


  /* ------------------------------------------------------- the conversation
     This field used to be a search box wearing Kai's clothes: a GET form
     posting to /pages/build-your-pack. Type "I want to get pregnant" and you
     were dumped onto a shopping page without Kai saying a word (KK 2026-08-26).
     Now she answers here.

     The shape she asked for: she says her piece, Kai offers a quick chat or a
     deep dive, and the conversation proceeds from whichever she picks.

     NO EMAIL GATE up front — KK 2026-08-26, deliberately: she wants to see
     whether people who reach a real recommendation convert, without the wall.
     Instead Kai offers to send the notes once the conversation has legs. This
     overrides the older always-gate rule for THIS surface only; the app and
     kai.conceivable.com are separate decisions.

     Without JS the form still submits to the pack builder, so the page never
     becomes a dead end. */

  var CHAT_API = 'https://kai.conceivable.com/api/kai-chat';
  var SUMMARY_API = 'https://kai.conceivable.com/api/kai-summary';
  var RECAP_API   = 'https://kai.conceivable.com/api/kai-recap';

  var FOLLOW_UP = 'Yes, of course. I’d be happy to help you with that. ' +
    'Can you tell me what’s going on? We can either do a quick chat or a deep dive.';

  var MODES = [
    { id: 'quick', label: 'Quick chat', note: 'a few minutes',
      hint: 'She wants a QUICK CHAT: keep it short, two or three exchanges, land on one concrete next step.' },
    { id: 'deep', label: 'Deep dive', note: 'the full picture',
      hint: 'She wants a DEEP DIVE: take a full history before you suggest anything. Ask about cycle, energy, sleep, stress and how long she has been trying, one question at a time.' }
  ];

  var SUMMARY_OFFER = 'Would you like me to email you the results of our conversation?';
  var SUMMARY_ASK = 'Perfect — what’s the best email for you?';
  // She hands over an email, and only then does Kai notice she never asked who
  // she's talking to. KK 2026-08-26 wanted it caught rather than smooth: a form
  // asks for your name up front, a person forgets and then apologises.
  var NAME_ASK = 'Oh gosh — I just realised I never asked your name.';
  // Two confirmations, because only one is true at a time: the server tells us
  // whether it actually went out, and promising an email that cannot be
  // delivered is worse than not offering at all.
  var SUMMARY_SENT = 'Done — your notes are on the way to ';
  var SUMMARY_HELD = 'Got it. I’ve got you at ';
  var SUMMARY_HELD_TAIL = ' and I’ll be in touch there.';
  var SUMMARY_SKIP = 'No problem. Keep going — what else is on your mind?';

  // How many of her turns before Kai offers to send the notes. Late enough
  // that there is something worth sending, early enough that she is still here.
  var OFFER_AFTER_TURNS = 3;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var form  = document.getElementById('cv-sh-ask');
  var field = form && form.querySelector('.cv-sh__field');
  var thread = root.querySelector('.cv-sh__thread');

  if (form && field && thread) {
    var history = [];      // [{role, content}] handed to Kai for context
    var opening = '';      // what she said first, answered once the gate opens
    var mode = null;       // 'quick' | 'deep'
    var email = '';
    var name = '';
    var sessionId = 'sh-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    var busy = false;
    var turns = 0;         // her turns since the conversation really started
    var offered = false;   // the notes offer is made once, never nagged
    var recapped = false;  // the wrap-up lands once, then the offer follows

    function scrollThread() {
      thread.scrollTop = thread.scrollHeight;
      setTimeout(function () { thread.scrollTop = thread.scrollHeight; }, 0);
    }

    function bubble(text, who) {
      var el = document.createElement('div');
      el.className = 'cv-sh__bubble' + (who === 'me' ? ' cv-sh__bubble--me' : '');
      el.textContent = text;
      thread.appendChild(el);
      scrollThread();
      return el;
    }

    function thinking() {
      var el = document.createElement('div');
      el.className = 'cv-sh__bubble cv-sh__bubble--wait';
      el.setAttribute('aria-label', 'Kai is typing');
      el.innerHTML = '<i></i><i></i><i></i>';
      thread.appendChild(el);
      scrollThread();
      return el;
    }

    /* Kai speaks on a short delay so a reply never lands in the same frame as
       the tap — it reads as an answer rather than a page state. */
    function kaiSays(text, then) {
      var wait = thinking();
      setTimeout(function () {
        wait.remove();
        bubble(text, 'kai');
        history.push({ role: 'assistant', content: text });
        if (then) then();
      }, 620);
    }

    function clearChoices() {
      var old = thread.querySelector('.cv-sh__choices');
      if (old) old.remove();
    }

    function offerModes() {
      clearChoices();
      var wrap = document.createElement('div');
      wrap.className = 'cv-sh__choices';
      MODES.forEach(function (m) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cv-sh__choice';
        b.innerHTML = '<strong></strong><em></em>';
        b.querySelector('strong').textContent = m.label;
        b.querySelector('em').textContent = m.note;
        b.addEventListener('click', function () {
          mode = m;
          clearChoices();
          bubble(m.label, 'me');
          history.push({ role: 'user', content: m.label });
          proceed();          // straight to the answer, no wall in front of it
        });
        wrap.appendChild(b);
      });
      thread.appendChild(wrap);
      scrollThread();
    }

    /* The wrap-up. Kai reflects back what she said and names what she'd start
       her on, right here in the thread. Before this the conversation just
       stopped dead and the only next step was handing over an email
       (KK 2026-08-26: "it just does nothing"). Value first, ask second. */
    function deliverRecap() {
      var wait = thinking();
      fetch(RECAP_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ transcript: history.slice(-14) })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          wait.remove();
          if (!d || !d.recap) { offerSummary(); return; }   // no recap, no theatre
          bubble(d.recap, 'kai');
          history.push({ role: 'assistant', content: d.recap });
          if (d.items && d.items.length) renderPicks(d.items);
          if (d.closer) setTimeout(function () { bubble(d.closer, 'kai'); }, 500);
          // Let her sit with it before asking for anything.
          setTimeout(function () { if (!offered && !email) offerSummary(); }, 2600);
        })
        .catch(function () { wait.remove(); offerSummary(); });
    }

    /* Her list, in the thread. Names and reasons, no prices: the number belongs
       on the cart page where she's actually deciding. */
    /* THE PACK, IN THE CONVERSATION (KK 2026-08-27).
       It used to be a list of names, and Kai pasted a link to the collection,
       which sends her out of the chat and she does not come back. This is the
       OK Capsule treatment: every product in its own box with its real
       photograph, what it does underneath, and the discount AFTER the pack
       rather than instead of it. */
    function findProduct(name) {
      var k = String(name || '').toLowerCase().trim();
      if (CATALOG[k]) return CATALOG[k];
      var keys = Object.keys(CATALOG);
      // "CoQ10" should find "CoQ10 200mg"; "Omega 3" should find "Omega-3".
      var norm = function (v) { return v.replace(/[^a-z0-9]/g, ''); };
      var target = norm(k);
      if (!target) return null;
      for (var i = 0; i < keys.length; i++) {
        var nk = norm(keys[i]);
        if (nk === target || nk.indexOf(target) === 0 || target.indexOf(nk) === 0) return CATALOG[keys[i]];
      }
      for (var j = 0; j < keys.length; j++) {
        if (norm(keys[j]).indexOf(target) !== -1) return CATALOG[keys[j]];
      }
      return null;
    }

    function renderPicks(items) {
      clearChoices();
      var wrap = document.createElement('div');
      wrap.className = 'cv-sh__picks';

      var head = document.createElement('div');
      head.className = 'cv-sh__picks-head';
      head.textContent = 'Your pack';
      wrap.appendChild(head);

      var sub = document.createElement('div');
      sub.className = 'cv-sh__picks-sub';
      sub.textContent = items.length + ' a day, sorted into one pouch. No bottles, no counting.';
      wrap.appendChild(sub);

      var grid = document.createElement('div');
      grid.className = 'cv-sh__pillgrid';
      items.forEach(function (i) {
        var p = findProduct(i.name);
        var box = document.createElement('div');
        box.className = 'cv-sh__pillbox';

        var shot = document.createElement('div');
        shot.className = 'cv-sh__pillshot';
        if (p && p.image) {
          var img = document.createElement('img');
          img.src = p.image;
          img.alt = '';
          img.loading = 'lazy';
          shot.appendChild(img);
        }
        box.appendChild(shot);

        var n = document.createElement('div');
        n.className = 'cv-sh__pillname';
        n.textContent = (p && p.name) || i.name;
        box.appendChild(n);

        var why = document.createElement('div');
        why.className = 'cv-sh__pillwhy';
        why.textContent = i.why || (p && p.short) || '';
        box.appendChild(why);

        grid.appendChild(box);
      });
      wrap.appendChild(grid);

      /* The discount comes after she has seen what is in it, never before. */
      var save = document.createElement('div');
      save.className = 'cv-sh__picks-save';
      save.textContent = 'Subscribe and save 15%. Skip, pause or cancel anytime.';
      wrap.appendChild(save);

      var cta = document.createElement('a');
      cta.className = 'cv-sh__picks-cta';
      /* KK 2026-09-13 audit: this opened an empty builder and her pack was lost.
         Carry Kai's picks so the builder opens with them already in it. */
      cta.href = '/pages/build-your-pack?pack=' + encodeURIComponent(items.map(function (i) {
        var p = findProduct(i.name);
        return (p && p.name) || i.name;
      }).join('|'));
      cta.textContent = 'Make this my pack';
      wrap.appendChild(cta);

      thread.appendChild(wrap);
      scrollThread();
    }

    function offerSummary() {
      offered = true;
      kaiSays(SUMMARY_OFFER, function () {
        clearChoices();
        var wrap = document.createElement('div');
        wrap.className = 'cv-sh__choices';
        [['Yes, email it to me', true], ['Not right now', false]].forEach(function (pair) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cv-sh__choice cv-sh__choice--slim';
          b.textContent = pair[0];
          b.addEventListener('click', function () {
            clearChoices();
            bubble(pair[0], 'me');
            if (pair[1]) askEmail(); else kaiSays(SUMMARY_SKIP);
          });
          wrap.appendChild(b);
        });
        thread.appendChild(wrap);
        scrollThread();
      });
    }

    function askEmail() {
      kaiSays(SUMMARY_ASK, function () {
        clearChoices();
        var wrap = document.createElement('form');
        wrap.className = 'cv-sh__choices cv-sh__gate';
        // Our own error state, not the browser's grey tooltip: native
        // validation swallows the submit event before the handler can style it.
        wrap.setAttribute('novalidate', 'novalidate');
        wrap.innerHTML =
          '<input type="email" class="cv-sh__gate-field" placeholder="you@email.com" ' +
          'autocomplete="email" aria-label="Your email">' +
          '<button type="submit" class="cv-sh__gate-go">Send it</button>';
        var input = wrap.querySelector('input');
        wrap.addEventListener('submit', function (e) {
          e.preventDefault();
          var v = input.value.trim();
          if (!EMAIL_RE.test(v)) { input.focus(); wrap.classList.add('is-bad'); return; }
          email = v;
          wrap.remove();
          bubble(v, 'me');
          try { localStorage.setItem('cv_sh_email', v); } catch (err) { /* private mode */ }
          askName();
        });
        input.addEventListener('input', function () { wrap.classList.remove('is-bad'); });
        thread.appendChild(wrap);
        scrollThread();
        input.focus();
      });
    }

    /* Skippable on purpose. Pushing for a name after she has already given her
       email is how a warm moment turns back into a form, so an empty submit
       just moves on and the email opens with "Hi," instead. */
    function askName() {
      kaiSays(NAME_ASK, function () {
        clearChoices();
        var wrap = document.createElement('form');
        wrap.className = 'cv-sh__choices cv-sh__gate';
        wrap.setAttribute('novalidate', 'novalidate');
        wrap.innerHTML =
          '<input type="text" class="cv-sh__gate-field" placeholder="First name" ' +
          'autocomplete="given-name" aria-label="Your first name">' +
          '<button type="submit" class="cv-sh__gate-go">That’s me</button>';
        var input = wrap.querySelector('input');
        wrap.addEventListener('submit', function (e) {
          e.preventDefault();
          var v = input.value.trim().slice(0, 40);
          wrap.remove();
          if (v) {
            name = v;
            bubble(v, 'me');
            try { localStorage.setItem('cv_sh_name', v); } catch (err) { /* private mode */ }
          }
          sendSummary(email);
        });
        thread.appendChild(wrap);
        scrollThread();
        input.focus();
      });
    }

    /* Hand the address and the transcript to the summary endpoint, then say
       whichever thing is true. A failure here never interrupts the
       conversation — she still gets the softer confirmation. */
    function sendSummary(address) {
      var held = function () { kaiSays(SUMMARY_HELD + address + SUMMARY_HELD_TAIL); };
      try {
        fetch(SUMMARY_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: address,
            name: name,
            source: 'storefront-supplements',
            mode: mode ? mode.id : null,
            sessionId: sessionId,
            transcript: history
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.sent) kaiSays((name ? 'Done, ' + name + ' — ' : SUMMARY_SENT.slice(0, 7)) + (name ? 'your notes are on the way to ' + address + '.' : SUMMARY_SENT.slice(7) + address + '.'));
            else held();
          })
          .catch(held);
      } catch (err) { held(); }
    }

    /* The gate is open: answer what she actually said at the very start. */
    function proceed() {
      send(opening, true);
    }

    function send(text, isOpening) {
      if (busy || !text) return;
      busy = true;
      form.classList.add('is-busy');
      var wait = thinking();
      var payload = {
        message: (mode ? '[' + mode.hint + ']\n\n' : '') + text,
        email: email,
        // KK 2026-08-27: this sent 6 messages, so Kai forgot what she said four
        // turns ago and re-asked it. The API keeps 16 now; send it 16.
        history: history.slice(-16),
        sessionId: sessionId,
        stream: true
      };

      // Stream the reply so words appear as they are written instead of after
      // the whole thing lands. Falls back to the old buffered read if the
      // browser or the response is not a stream (KK: "its slow").
      function finish(reply) {
        history.push({ role: 'user', content: text });
        history.push({ role: 'assistant', content: reply });
        turns++;
        if (!recapped && turns >= OFFER_AFTER_TURNS) {
          recapped = true;
          setTimeout(deliverRecap, 800);
        }
        busy = false;
        form.classList.remove('is-busy');
        if (!isOpening) field.focus();
      }

      fetch(CHAT_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          var ct = (r.headers.get('content-type') || '');
          if (ct.indexOf('text/event-stream') === -1 || !r.body || !window.TextDecoder) {
            return r.json().then(function (d) {
              wait.remove();
              var reply = (d && d.response) || 'I’m here. Tell me a little more?';
              bubble(reply, 'kai');
              finish(reply);
            });
          }
          wait.remove();
          var el = bubble('', 'kai');
          var reader = r.body.getReader();
          var dec = new TextDecoder();
          var buf = '';
          var full = '';
          function pump() {
            return reader.read().then(function (res) {
              if (res.done) { finish(full || 'I’m here. Tell me a little more?'); return; }
              buf += dec.decode(res.value, { stream: true });
              var lines = buf.split('\n');
              buf = lines.pop() || '';
              for (var i = 0; i < lines.length; i++) {
                var ln = lines[i];
                if (ln.indexOf('data:') !== 0) continue;
                var raw = ln.slice(5).trim();
                if (!raw) continue;
                var ev;
                try { ev = JSON.parse(raw); } catch (e) { continue; }
                if (ev.t) {
                  full += ev.t;
                  if (el && el.textContent !== undefined) el.textContent = full;
                  scrollThread();
                }
                if (ev.done && ev.response) full = ev.response;
              }
              return pump();
            });
          }
          return pump();
        })
        .catch(function () {
          wait.remove();
          bubble('I lost you for a second there. Say that again?', 'kai');
          busy = false;
          form.classList.remove('is-busy');
          if (!isOpening) field.focus();
        });
    }

    /* First thing she says opens the conversation; everything after goes
       straight to Kai. */
    /* KK 2026-08-27: the first reply was a canned sentence. A woman types the
       hardest thing about her body and gets "Yes, of course. I'd be happy to
       help you with that." She can tell. Kai now actually reads what she
       wrote, answers it in Kirsten's voice, and then offers the two ways to
       carry on. The canned line survives only as the fallback if the API is
       down, because silence would be worse. */
    function say(text) {
      if (!text || busy) return;
      bubble(text, 'me');
      field.value = '';
      if (!opening) {
        opening = text;
        history.push({ role: 'user', content: text });
        openingReply(text);
        return;
      }
      send(text);
    }

    function openingReply(text) {
      busy = true;
      form.classList.add('is-busy');
      var wait = thinking();
      var hint = '[This is the first thing she has said. Read it and respond to THAT, ' +
        'in two or three sentences: show her you heard the specific thing she said, and ' +
        'say one true thing about it that she probably has not been told. Warm, direct, ' +
        'no preamble, never "I would be happy to help". Do not ask a question at the end ' +
        'and do not list anything yet, she is about to be offered two ways to carry on.]';
      fetch(CHAT_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: hint + '\n\n' + text, email: email, history: [], sessionId: sessionId })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          wait.remove();
          var reply = (d && d.response) || FOLLOW_UP;
          bubble(reply, 'kai');
          history.push({ role: 'assistant', content: reply });
        })
        .catch(function () {
          wait.remove();
          bubble(FOLLOW_UP, 'kai');
          history.push({ role: 'assistant', content: FOLLOW_UP });
        })
        .then(function () {
          busy = false;
          form.classList.remove('is-busy');
          offerModes();
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();                   // never navigate away again
      var v = field.value.trim();
      if (!v) { field.focus(); return; }
      say(v);
    });

    /* The ellipsis breathes so the field reads as a cursor waiting on her
       rather than a label (KK 2026-08-26). Placeholder text can't be animated
       in CSS, so we cycle the attribute. Stops while she is typing, and stops
       entirely for anyone who asked for less motion. */
    (function animatePlaceholder() {
      var BASE = 'Start typing';
      var reduced = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) { field.placeholder = BASE + '...'; return; }
      var step = 0;
      setInterval(function () {
        // Never fight her: only animate an empty, unfocused field.
        if (field.value || document.activeElement === field) return;
        step = (step + 1) % 4;
        field.placeholder = BASE + '...'.slice(0, step);
      }, 420);
    })();

    /* A chip fills the field so she can see and edit what she is about to
       say; a second click on the same chip sends it. */
    root.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('[data-say]') : null;
      if (!chip) return;
      e.preventDefault();
      var text = chip.getAttribute('data-say');
      if (field.value.trim() === text) { say(text); return; }
      field.value = text;
      field.focus();
      field.setSelectionRange(text.length, text.length);
    });
  }

  /* ----------------------------------------------------------- rotating name */

  var slot = document.getElementById('cv-sh-name');
  if (!slot) return;

  var names = ['Sarah', 'Maya', 'Priya', 'Elena', 'Nicole', 'Jess', 'Amara', 'Lauren'];
  var i = 0;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) { slot.textContent = names[0]; return; }

  slot.textContent = names[0];
  slot.style.transition = 'opacity .32s ease';
  setInterval(function () {
    slot.style.opacity = '0';
    setTimeout(function () {
      i = (i + 1) % names.length;
      slot.textContent = names[i];
      slot.style.opacity = '1';
    }, 320);
  }, 2600);
})();
